<template>
    <div class='conversation-list'>
        <template v-for="conversation in processConversations(conversations)">
            <conversation-list-item class="box is-radiusless is-marginless"
                                    :conversation="conversation"
                                    :key="conversation.id" />
        </template>

        <div v-if="isLoading"
             class="box is-radiusless is-marginless has-text-centered">
            Indlæser.. <b-icon icon="loading"
                    custom-class="mdi-spin"
                    size="is-small" />
        </div>
    </div>
</template>

<script>
import ConversationListItem from '@/taskflex/conversations/components/ConversationListItem';
import ConversationService from '@/taskflex/conversations/services/ConversationService';

export default {
    data() {
        return {
            conversations: [],
            isLoading: false,
            page: 1,
            limit: 999,
            total: null,
        };
    },

    props: {
        initialConversation: {
            required: true,
            type: Object,
        },
    },

    mounted() {
        this.conversations.push(this.initialConversation);

        this.loadConversations();
    },

    methods: {
        processConversations(conversations) {
            // Statuses indicating that a project is open
            const openStatuses = new Set(["project-clarification", "project-created", "project-offer-posted", "project-offer-accepted"]);

            // Add openStatus to project
            const processedConversations = conversations
                .map(conversation => {
                    // Check if conversation has a project
                    if (conversation.project === null) {
                        return conversation;
                    }

                    return {
                        ...conversation,
                        project: {
                            ...conversation.project,
                            openStatus: openStatuses.has(conversation.project.status),
                        },
                    };
                });

            return processedConversations.sort((a, b) => {
                // Primary sort: openStatus (open projects first)
                if ((a.project && a.project.openStatus) !== (b.project && b.project.openStatus)) {
                    return (a.project && a.project.openStatus) ? -1 : 1;
                }

                // Secondary sort: updated_at
                if (a.project && b.project) {
                    return b.project.updated_at - a.project.updated_at;
                }

                return 0;
            });
        },
        loadConversations() {
            this.isLoading = true;

            const options = {
                includes: [
                    'project',
                    'addressee',
                    'sender',
                    'latestMessage.sender',
                ],
                sort: [
                    {
                        key: 'updated_at',
                        direction: 'desc',
                    },
                ],

                limit: this.limit,
                page: this.page,
            };
            
            ConversationService.findAll(options, ({ data: { rows } }) => {
                this.conversations = rows;

                this.isLoading = false;
            });
        },
    },

    components: {
        ConversationListItem,
    },
};
</script>



// WEBPACK FOOTER //
// src/taskflex/conversations/components/ConversationList.vue